import { BOOKTICKET, DELETETICKET } from "./actionsTypes";

let initialState = [];

const flightBookAppReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOKTICKET:
      return [...state, action.payload];
    case DELETETICKET:
      return state.filter((ticket) => {
        if (ticket?.id !== action.payload) {
          return ticket;
        }
      });
    default:
      return state;
  }
};

export default flightBookAppReducer;
